import React, { FC } from 'react';

import { Typography } from '@mui/material';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import ChevronLeftIcon from '../../../../assets/icons/ChevronLeftIcon';
import { colorsPalette } from '../../../../theme';
import { DEFAULT_URL } from '../../../DiscoverPage/const';
import useStyles from './styles';

interface PathwayNavigationProps {
  wrapperClass?: string;
  pathwayName?: string | null;
  pathwaySlug?: string | null;
  'data-testid'?: string;
}

const PathwayNavigation: FC<PathwayNavigationProps> = ({
  wrapperClass = '',
  pathwayName,
  pathwaySlug,
  ...rest
}) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Link
      className={cx(classes.pathwayInfo, wrapperClass)}
      to={`${DEFAULT_URL}/pathways/${pathwaySlug}`}
      data-testid={rest['data-testid']}
    >
      <ChevronLeftIcon className={classes.pathwayIcon} color={colorsPalette.blue} />
      <Typography className={classes.pathwayTitle}>
        {t('page.video.pathwayName', { pathwayName })}
      </Typography>
    </Link>
  );
};

export default PathwayNavigation;
